import { archiveList } from '@/mocks/home';

export default function ArchiveIndex() {
  return (
    <section id="archive" className="w-full px-4 md:px-8 py-12 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4 border-b border-background-300 pb-5">
        <div>
          <span className="text-xs font-label tracking-[0.3em] text-primary-600">07 / 归档索引</span>
          <h3 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">全部期数索引</h3>
        </div>
        <span className="text-xs md:text-sm font-label text-foreground-500">共 92 期 · 显示最近 8 期</span>
      </div>

      <div className="mt-6 border-t border-background-200">
        <div className="hidden md:grid grid-cols-12 gap-4 border-b border-background-200 px-2 py-3 text-xs font-label tracking-wide text-foreground-500">
          <span className="col-span-2">期号</span>
          <span className="col-span-6">合集名称</span>
          <span className="col-span-2">分区</span>
          <span className="col-span-1">更新</span>
          <span className="col-span-1 text-right">操作</span>
        </div>

        {archiveList.map((row) => (
          <a
            key={row.index}
            href="#archive"
            className="group grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 items-center border-b border-background-200 px-2 py-4 transition-colors hover:bg-background-100 cursor-pointer"
          >
            <span className="md:col-span-2 font-heading text-sm md:text-base font-bold text-primary-600">{row.index}</span>
            <span className="md:col-span-6 text-sm md:text-base text-foreground-900 transition-colors group-hover:text-primary-600">
              {row.title}
            </span>
            <span className="md:col-span-2">
              <span className="inline-block rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-label text-secondary-900">
                {row.category}
              </span>
            </span>
            <span className="md:col-span-1 text-xs md:text-sm font-label text-foreground-500">{row.updated}</span>
            <span className="md:col-span-1 md:text-right">
              <span className="inline-flex items-center gap-1 text-xs font-label text-foreground-600 transition-transform group-hover:translate-x-0.5">
                查看
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </span>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}